module.exports = __webpack_public_path__ + "static/media/invoicing-settings.f0669d50.png";